import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Button from 'reactstrap/lib/Button';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';
import './high-impact-controls.scss';

export function HighImpactControls({ slides, updateSelectedSlide, selectedSlideIndex }) {
  return (
    <Row className="high-impact-controls pb-2 mx-0" role="tablist">
      {slides.map((slideItem, index) => (
        <Col
          xs={12 / slides.length}
          key={slideItem.id}
          className="high-impact-controls-tile d-flex align-items-end"
          role="presentation"
        >
          <Button
            onClick={updateSelectedSlide}
            value={index}
            className={classNames('high-impact-control-button text-center w-100 py-0', {
              'selected-button': selectedSlideIndex === index,
            })}
            role="tab"
            id={`tab-${slideItem.id}`}
            aria-selected={selectedSlideIndex === index}
            aria-controls={`tabpanel-${slideItem.id}`}
          >
            <div
              className={classNames('advertiser-name size-24 fw-medium d-inline-block px-0_5', {
                'text-cool-gray-10': selectedSlideIndex === index,
                'text-cool-gray-50': selectedSlideIndex !== index,
              })}
            >
              <ContentFragment componentToUse="span" classes="pos-r d-inline-block py-0_25">
                {slideItem.metadata('advertiserName').value()}
              </ContentFragment>
            </div>
          </Button>
        </Col>
      ))}
    </Row>
  );
}

HighImpactControls.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  updateSelectedSlide: PropTypes.func.isRequired,
  selectedSlideIndex: PropTypes.number.isRequired,
};
